import { SearchForMedicalPaOrdersFromPostgresParams } from "../../../../api/postgreSQL/postCalls/searchForMedicalPaOrdersFromPostgres";

/**
 * Generates an array of search payloads for the initial data fetch, one per page
 * from page 0 through batchNumber (inclusive). Used to restore previously fetched pages
 * when the table re-mounts. Also stamps the active server-side sort onto each page
 * payload so the restored data is fetched in the same order the user last saw.
 *
 * @param payload - Base search payload to replicate per page
 * @param batchNumber - Last batch/page index to include (0-based)
 * @param searchTerm - Search query to apply to each payload
 * @param sortByField - Canonical backend field name to sort by (empty string for no sort)
 * @param sortAscending - Sort direction; true for ascending, false for descending
 * @returns Array of search payloads with incrementing page numbers
 */
export const generatePayloadForInitialDataFetch = (
  payload: SearchForMedicalPaOrdersFromPostgresParams,
  batchNumber: number,
  searchTerm: string,
  sortByField: string,
  sortAscending: boolean,
): SearchForMedicalPaOrdersFromPostgresParams[] => {
  const arraysFromBatchNumber = Array.from(
    { length: batchNumber + 1 },
    (_, index) => index,
  );
  return arraysFromBatchNumber.map((index) => ({
    ...payload,
    page: index,
    query: searchTerm,
    sort_by: sortByField,
    sort_dir: sortAscending ? "asc" : "desc",
  }));
};
